/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LobbyImageContentIdGet$Params {
  id: string;
}

export function lobbyImageContentIdGet(http: HttpClient, rootUrl: string, params: LobbyImageContentIdGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, lobbyImageContentIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as ACSStrictHttpResponse<void>;
    })
  );
}

lobbyImageContentIdGet.PATH = '/Lobby/ImageContent/{id}';
